<template>
  <div class="wapper">
    <HeadBack title="忘记交易密码"></HeadBack>
    <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="手机号或邮箱" class="yzm">
        <!-- <el-input v-model="ruleForm.pe" autocomplete="off" placeholder="请输入您所绑定的手机号或邮箱"></el-input> -->
        <el-input v-model="showAccount" autocomplete="off" placeholder="请输入您所绑定的手机号或邮箱" disabled></el-input>
        <el-button @click="getYzm" class="getyzm" :disabled="disabled"> {{ yzmValue }} </el-button>
      </el-form-item>
      <el-form-item label="验证码">
        <el-input v-model="ruleForm.valcode" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="登录密码">
        <el-input v-model="ruleForm.loginPassword" autocomplete="off" type="password"></el-input>
      </el-form-item>
      <el-form-item label="新交易密码">
        <el-input v-model="ruleForm.oldPass" autocomplete="off" type="password"></el-input>
      </el-form-item>
      <el-form-item label="再次输入密码">
        <el-input v-model="ruleForm.pass" autocomplete="off" type="password"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm">确定</el-button>
        <!-- <el-button @click="resetForm">重置</el-button> -->
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import HeadBack from '../../components/HeadBack.vue'
  import g from '@/components/Global'
  export default {
    name: 'resetDealPass',
    data() {
      return {
        ruleForm: {
          loginPassword: '',
          pe: '',
          valcode: '',
          oldPass: '',
          pass: '',
        },
        yzmValue: '获取验证码',
        num: 60,
        flag: false,
        disabled: false,
        showAccount: '',      //显示的打码账号
      }
    },
    methods: {
      getYzm() {
        if(!this.ruleForm.pe){
          this.$Message.error('请先填写手机号或邮箱');
          return
        }
        this.disabled = true
        this.flag = true
        this.axios.post('client/sendValCode.do',this.qs.stringify({
          pe: this.ruleForm.pe,
			    verificationCodeType: 'CLIENT_RESET_TRADE_CODE'
        })).then(result => {
          
        })
        let time = setInterval(()=>{
          this.num = this.num-1
          this.yzmValue = this.num
          if(this.num == 0){
            clearInterval(time)
            this.num = 60
            this.yzmValue = "获取验证码"
            this.disabled = false
          }
        },1000)
      },
      submitForm() {
        if(!this.ruleForm.pe) {
          this.$Message.error('请输入手机号或邮箱');
          return
        }
        if(!this.flag) {
          this.$Message.error('请先获取验证码');
          return
        }
        if(!this.ruleForm.valcode) {
          this.$Message.error('请输入验证码');
          return
        }
        if(!this.ruleForm.loginPassword) {
          this.$Message.error('请输入登录密码');
          return
        }
        if(!this.ruleForm.oldPass) {
          this.$Message.error('请输入新交易密码');
          return
        }
        if(!this.ruleForm.pass) {
          this.$Message.error('请再次输入交易密码');
          return
        }
        if(this.ruleForm.oldPass !== this.ruleForm.pass) {
          this.$Message.error('两次密码输入不一致');
          return
        }

        this.axios.post('clientbind/resetClientBindTradePassword.do', this.qs.stringify({
          clientBindId: this.bdID,
          loginPassword: this.encryption(this.ruleForm.loginPassword),
          pe: this.ruleForm.pe,
          valcode: this.ruleForm.valcode,
          tradePassword: this.encryption(this.ruleForm.pass),
        })).then(result => {
          if(result.data.success) {
            this.$Message.success('交易密码重置成功');
            this.resetData()
          }
        })
      },
      resetData() {
        this.ruleForm = {
          loginPassword: '',
          pe: '',
          valcode: '',
          oldPass: '',
          pass: '',
        }
        this.changeShowAccount()
      },
      changeShowAccount() {
        if(this.userData.phoneNumber) {
           this.ruleForm.pe = this.userData.phoneNumber
           this.showAccount = this.ruleForm.pe.substring(0, 3) + "****" + this.ruleForm.pe.substring(this.ruleForm.pe.length - 3, this.ruleForm.pe.length)
        } else {
          this.ruleForm.pe = this.userData.email
          let arr = this.ruleForm.pe.split("@")
          let n = 3
          if(arr[0].length <= 6) {
            n = 2
          }
          this.showAccount = arr[0].substring(0, n) + "****" + arr[0].substring(arr[0].length - n, arr[0].length) + "@" + arr[1]
        }
      },
    },
    computed:{
      bdID(){
        return this.$store.state.bdID
      },
      userData() {
        return this.$store.state.bdobj
      },
    },
    components: {
      HeadBack,
    },
    watch: {
      $route: {
        handler(to, from) {
          if(to.path == '/resetDealPass') {
            this.resetData()
          }
        },
        immediate: true,
      }
    }
  }
</script>

<style scoped>
.wapper {
  margin-top: 45px;
}
.yzm {
  position: relative;
}
.getyzm {
  position: absolute;
  right: 0;
  top: 0;
}
</style>